<template>
  <div class="container">
    <div class="row">
      <div class="overviewAndNav">
        <div class="header-container"><h3>Overzicht {{ this.currentlySelectedMonth | toMonthNameWithYear }}</h3></div>
        <div class="col-lg-4 button-container">
          <button
              class="btn-basic btn-outline-pulse-dark mr-2 button-lock-everything" :disabled="false"
              @click="handleConfirm()" v-if="notAllAreLocked()">Alles vergrendelen
          </button>
          <button
              class="btn btn-dark button-previous-month" @click="previousMonth">
            <svg
                class="bi bi-chevron-left" fill="currentColor"
                height="1em" viewBox="0 0 16 16"
                width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
                  fill-rule="evenodd"/>
            </svg>
          </button>
          <button
              class="btn btn-dark ml-1 button-next-month" @click="nextMonth">
            <svg
                class="bi bi-chevron-right" fill="currentColor"
                height="1em" viewBox="0 0 16 16"
                width="1em" xmlns="http://www.w3.org/2000/svg">
              <path
                  d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z"
                  fill-rule="evenodd"/>
            </svg>
          </button>
          <button class="btn-basic btn-outline-pulse-dark button-pulse-exclamation"
              @click="handleEBloxRequest(hrEmployer.id)"
              v-bind:key="hrEmployer.id"
              v-for="hrEmployer in hrEmployers">{{ hrEmployer.name }} EBlox
          </button>
          <button class="btn-basic btn-outline-pulse button-new-invoice"
              @click="showCustomInvoicePage()">
            Nieuwe factuur
          </button>
          <button class="btn-basic btn-outline-pulse-dark button-showPulse" @click="togglePulseRows">
            {{ hidePulseRows ? 'Toon Pulse' : 'Verberg Pulse' }}
          </button>
        </div>
      </div>
    </div>
    <div class="row my-2">
      <input
          ref="focusMe"
          type="text"
          class="form-control"
          placeholder="Zoeken op naam van personeelslid of ziekenhuis..."
          v-model="search"/>
    </div>
    <div class="row">
      <div class="table-responsive">
        <table class="table table-bordered table-hover">
          <thead class="thead-dark">
          <tr>
            <SortableTableHeaderComponent
                columnName="contractId" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="ID" style="width: 70px;"/>
            <SortableTableHeaderComponent
                columnName="username" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Naam personeel"/>
            <SortableTableHeaderComponent
                columnName="customerName" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Ziekenhuis"/>
            <SortableTableHeaderComponent
                columnName="Vergrendeld" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Planning vergrendeld"/>
            <SortableTableHeaderComponent
                columnName="completed" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Timehseet bevestigd"/>
            <SortableTableHeaderComponent
                columnName="approved" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Goedgekeurd door klant"/>
            <SortableTableHeaderComponent
                columnName="workedHours" :sortColumn="currentSortColumn"
                :sortDirectionAscending="currentSortDirectionAscending" :sortFunction="sort"
                text="Totaal gewerkte uren"/>
            <th scope="col">Actie</th>
          </tr>
          </thead>
          <tr v-if="isLoading">
            <td colspan="6">
              <Bouncer/>
            </td>
          </tr>
          <tbody v-else v-for="(contract, index) in sortedContractRow" v-bind:key="index">
          <AdminContractRowComponent
              :index="index +1"
              :contract="contract"
              :key="contract.id"/>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations} from "vuex";
import AdminContractRowComponent from "../Admin/AdminContractSpecificDashboard/AdminContractRowComponent";
import Bouncer from "@/components/loader/Bouncer";
import {sortListByColumnAndDirection} from "@/util/SortingUtil";
import SortableTableHeaderComponent from "@/components/tables/SortableTableHeader";

export default {
  name: "AdminContractViewComponent",
  components: {
    SortableTableHeaderComponent,
    Bouncer,
    AdminContractRowComponent,
  },
  data() {
    return {
      isLoading: true,
      currentSortColumn: "username",
      currentSortDirectionAscending: true,
      search: '',
      hidePulseRows: false,
    };
  },
  computed: {
    ...mapGetters({
      contractWithTimeSheetInfo: 'administrationTimeSheet/contractWithTimeSheetInfo',
      hrEmployers: "administrationUser/hrEmployers",
      currentlySelectedMonth: "time/currentlySelectedMonth"
    }),
    sortedContractRow: function () {
      let sortedList;

      if (this.currentSortColumn === "completed") {
        sortedList = sortListByColumnAndDirection(this.contractWithTimeSheetInfo, this.currentSortColumn, this.currentSortDirectionAscending, this.completedFirst);
      } else {
        sortedList = sortListByColumnAndDirection(this.contractWithTimeSheetInfo, this.currentSortColumn, this.currentSortDirectionAscending);
      }

      sortedList = sortedList.filter(contract => {
        return (
            contract.username.toLowerCase().includes(this.search.toLowerCase()) ||
            contract.customerName.toLowerCase().includes(this.search.toLowerCase())
        );
      });

      if (this.hidePulseRows) {
        sortedList = sortedList.filter(contract => {
          return !['Pulse!', 'PulseHCS'].includes(contract.customerName);
        });
      }

      return sortedList;
    },
  },
  watch: {
    hidePulseRows(newValue) {
      sessionStorage.setItem('hidePulseRows', newValue);
    }
  },
  mounted() {
    this.$refs.focusMe.focus();
  },
  async created() {
    this.fetchContractWithTimeSheetInfo()
        .then(() => this.isLoading = false);
    await this.fetchUsers();
    await this.fetchHREmployers();
    const hidePulseRows = sessionStorage.getItem('hidePulseRows');
    this.hidePulseRows = hidePulseRows === 'true';
  },
  methods: {
    ...mapActions("administrationTimeSheet", ["fetchContractWithTimeSheetInfo", "unlockTimeSheet", "lockAllPlannings", "downloadEBloxForHREmployer"]),
    ...mapActions("administrationUser", ["fetchHREmployers", "fetchUsers"]),
    ...mapMutations({
      setCurrentlySelectedContractIndex: "administrationTimeSheet/setCurrentlySelectedContractIndex",
      addMonth: "time/addMonth",
      subtractMonth: "time/subtractMonth",
      lockAll: "administrationContract/lockAll"
    }),
    togglePulseRows() {
      this.hidePulseRows = !this.hidePulseRows;
    },
    sort: function (newSortColumn) {
      if (newSortColumn === this.currentSortColumn) {
        this.currentSortDirectionAscending = !this.currentSortDirectionAscending;
      } else {
        this.currentSortDirectionAscending = true;
      }
      this.currentSortColumn = newSortColumn;
    },
    completedFirst(completed) {
      return !completed;
    },
    previousMonth() {
      this.subtractMonth();
      this.fetchContractWithTimeSheetInfo();
    },
    nextMonth() {
      this.addMonth();
      this.fetchContractWithTimeSheetInfo();
    },
    handleConfirm() {
      if (confirm('Ben je zeker dat je al de planningen voor deze maand wilt vastzetten?')) {
        this.lockAllPlannings();
      }
    },
    notAllAreLocked() {
      return this.contractWithTimeSheetInfo.filter(contractInfo => contractInfo.locked === false).length > 0;
    },
    handleEBloxRequest(hrEmployerId) {
      this.downloadEBloxForHREmployer(hrEmployerId);
    },
    showCustomInvoicePage() {
      this.$router.push({path: "/admin/viewCustomInvoice"});
    }
  },
};
</script>

<style scoped>

.overviewAndNav {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

td {
  vertical-align: middle;
}

.button-container {
  display: flex;
  flex-direction: row-reverse;
}

.button-next-month {
  order: 1;
}

.button-previous-month {
  order: 2;
  margin-left: 20px;
}

.button-lock-everything {
  order: 3;
  margin-right: 8px;
}

.button-showPulse {
  order: 4;
  margin-right: 8px;
}

.button-pulse-exclamation {
  order: 5;
  margin-right: 8px;
}

.button-new-invoice {
  order: 6;
  margin-right: 8px;
}

</style>
